export default __webpack_public_path__ + "static/deals-modal-discount-bc5c7e2fdca8275c075323325fcb422d.png";